import React from 'react';
import MemberSearchBox from '@alltrails/shared/components/MemberSearchBox';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import CustomProvider from 'components/CustomProvider';

import * as styles from './styles/styles.module.scss';

type MemberSearchBoxContainerProps = {
  languageRegionCode: LanguageRegionCode;
};

const MemberSearchBoxContainer = ({ languageRegionCode }: MemberSearchBoxContainerProps): JSX.Element => (
  <CustomProvider>
    <MemberSearchBox languageRegionCode={languageRegionCode} className={styles.searchBoxContainer} />
  </CustomProvider>
);

export default MemberSearchBoxContainer;
